module.exports = __webpack_public_path__ + "static/media/Empty_Cart.016eebcc.svg";